import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-datatata',
  templateUrl: './datatata.component.html',
  styleUrls: ['./datatata.component.scss']
})
export class DatatataComponent implements OnInit {

  @Input() theme: string = 'dark'; // dark, light, blue
  @Input() text: string;
  @Input() lang: string = 'en';

  constructor() { }

  ngOnInit() {
    // console.log('text', this.text);
  }

}
